'use client'

import Typography from '@mui/material/Typography'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FC } from 'react'
import Banner from '../../shared/components/Banner'
import BlankTargetLink from '../../shared/components/BlankTargetLink'
import GridContainer from '../../shared/components/GridContainer'
import GridLayout from '../../shared/components/GridLayout'
import useViewPage from '../../shared/hooks/useViewPage'
import events from '../../constants/analytics'

const NotFoundPage: FC = () => {
  const pathname = usePathname()

  useViewPage(events.EVENTS.INIT.ViewNotFoundPage, { pathname })

  return (
    <>
      <Banner title="Hmm... Something isn't right." label="Mission Lane" />
      <div className="py-12 md:py-24">
        <GridContainer>
          <GridLayout>
            <Typography variant="p1">
              We couldn&apos;t find the page you&apos;re looking for. Return to the{' '}
              <span>
                <Link href="/">homepage</Link> or head to our{' '}
                <BlankTargetLink href="https://support.missionlane.com/hc/en-us">
                  FAQ
                </BlankTargetLink>{' '}
                for help.
              </span>
            </Typography>
          </GridLayout>
        </GridContainer>
      </div>
    </>
  )
}

export default NotFoundPage
